//@flow
//$FlowFixMe
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button, useInput } from 'sputnik-ui'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@material-ui/core'

import {} from 'store/operations'
import { sendMoney } from '../../../store/companies/operations'

const Transition = props => <Slide direction="up" {...props} />

const VIRTUAL_PAYMENT_TYPES = [
  { label: 'Выплата - без денег, УПД на эту сумму уменьшается', value: 'payout_without_money' },
  { label: 'Компенсация - сумма УПД не меняется', value: 'compensation' },
  { label: 'Начисление по партнерской программе - считаем отдельно, УПД не меняется', value: 'partner_program_accrual' },
  { label: 'Выплата по ключам - на эту сумму УПД уменьшается', value: 'payout_by_keys' },
  { label: 'ВЭД-Выплата - без денег, УПД на эту сумму уменьшается', value: 'ved_payout_without_money' },
  { label: 'ВЭД - Компенсация - сумма УПД не меняется', value: 'ved_compensation' },
  { label: 'ВЭД-Начисление по партнерской программе - считаем отдельно, УПД не меняется', value: 'ved_partner_program_accrual' },
]

const REAL_PAYMENT_TYPES = [
  { label: 'Счет', value: 'invoice' },
  { label: 'ВЭД - счет', value: 'ved_invoice' },
]

const ReassignIntercomModal = ({
  open,
  selectedCompany,
  sendingMoney,
  handleClose,
  dispatch,
}: Props) => {
  const { value: amount, bind: bindAmount } = useInput('')
  const { value: comment, bind: bindComment } = useInput('')
  const { value: virtual, setValue: setVirtual } = useInput(false)
  const [paymentType, setPaymentType] = useState('')

  const handleTabChange = (_, newValue) => {
    setVirtual(newValue === 0)
    setPaymentType('')
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(sendMoney({ virtual, amount, comment, paymentType, companyUuid: selectedCompany })).then(
      () => {
        handleClose()
      },
    )
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{ style: styles.dialogWindow }}
      onExit={() => {}}
    >
      <DialogTitle>Насыпать денег</DialogTitle>
      <Typography variant="body2" style={{ padding: '0 24px' }}>
        Имейте в виду: если компания заблокирована, пополнение её баланса выше нуля автоматически разблокирует её.
      </Typography>
      <br />
      <form onSubmit={handleSubmit}>
        <DialogContent style={{ overflow: 'visible', paddingTop: 0 }}>
          <Tabs value={virtual ? 0 : 1} onChange={handleTabChange} indicatorColor="primary" textColor="primary" style={{ marginBottom: '1rem', backgroundColor: '#f5f5f5', borderRadius: 4 }}>
            <Tab label="Виртуальные" style={{ fontWeight: virtual ? 700 : 400 }} />
            <Tab label="Реальные" style={{ fontWeight: !virtual ? 700 : 400 }} />
          </Tabs>
          <FormControl fullWidth style={{ marginBottom: '.325rem' }}>
            <InputLabel>Основание операции</InputLabel>
            <Select value={paymentType} onChange={e => setPaymentType(e.target.value)}>
              {(virtual ? VIRTUAL_PAYMENT_TYPES : REAL_PAYMENT_TYPES).map(type => (
                <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Cумма"
            {...bindAmount}
            autoFocus
            fullWidth
            style={{ marginBottom: '.325rem' }}
          />
          <TextField label="Комментарий" style={{ marginBottom: '.325rem' }} {...bindComment} fullWidth />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            secondary
            rounded
            size="small"
            tabIndex={-1}
          >
            закрыть
          </Button>
          <Button
            rounded
            primary
            size="small"
            onClick={handleSubmit}
            disabled={!amount || !paymentType || sendingMoney}
            type="submit"
          >
            насыпать{sendingMoney && '...'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

type MS = {
  selectedCompany: string,
  sendingMoney: boolean,
}

type Props = {
  open: boolean,
  handleClose: Function,
  dispatch: Function,
} & MS

const styles = {
  dialogWindow: { overflow: 'visible', minWidth: 418 },
}

const mapStateToProps = ({ companies }): MS => ({
  companies: companies.list,
  selectedCompany: companies.selected && companies.selected.value,
  sendingMoney: companies.sendingMoney,
})

export default connect(mapStateToProps)(ReassignIntercomModal)
